













import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        mdbBtn: () => import('@folky-tools/mdbvue/src/components/Components/Button.vue'),
        mdbIcon: () => import('@folky-tools/mdbvue/src/components/Content/Fa.vue')
    }
})
export default class NavbarLoggedOut extends Vue {
    private entering: boolean = false;

    private enterClicked() {
        this.entering = true;
        this.$router.push('/dashboard');
    }
}
